import React, { useEffect, useState } from "react";
import { ENDPOINTS } from "../../js/api/_config";
import axios from "axios";

import { Toast } from "../common/toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { getTrailsName } from "../../reducer/slices/trial/get-trial-name-slice";
import { BackButton } from "../common/back-button/back-button";
import CountrySelector from "../common/country-selector/country-selector";
import { countryCodes } from "../common/country-selector/constant";

const AddIndividualPatient = () => {
  const [addFirstName, setAddfirstName] = useState('');
  const [addLastName, setAddLastName] = useState('');
  const [addEmail, setAddEmail] = useState('');
  const [addPhoneNumber, setAddPhoneNumber] = useState('');
  const [addCountryCode, setAddCountryCode] = useState('+1');
  const [toasts, setToasts] = useState([]);
  const [errors, setErrors] = useState({});
  const trialNamesList = useSelector(state => state.trails_name.data || [])
  const [trailsName, setTrailsName] = useState();
  const [selectedTrailsNameId, setSelectedTrailsNameId] = useState();
  const [trialIntro, setTrailIntro] = useState();
  const [trialIntroId, setTrailIntroId] = useState();
  const [trialIntroLabel, setTrailIntroLabel] = useState();
  const [apiLoader, setApiLoader] = useState(false)
  
  const dispatch = useDispatch();



  const handleSelectChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setTrailsName(selectedName?selectedName:"")
    const selectedTrailNames = trialNamesList.find((tz) => tz.trialName === selectedName);
    setTrailIntro(selectedTrailNames?selectedTrailNames.trialsIntroductionDataModels:null)
    setSelectedTrailsNameId(selectedTrailNames?selectedTrailNames.trialID:null)
    setTrailIntroId("");
    setTrailIntroLabel("");
  };

  const handleSelectTrailIntroChange = (e) => {
    const selectedTrailIntroName = e.target.value; // Get the selected timezone
    // setTrailsName(selectedTrailIntroName)

    const selectedTrailIntroduction = trialIntro.find((tz) => tz.trialIntroductionLabel === selectedTrailIntroName);
    setTrailIntroId(selectedTrailIntroduction.trialIntroductionID)
    setTrailIntroLabel(selectedTrailIntroduction.trialIntroductionLabel)
  };


  const validate = () => {
    const newErrors = {};

    // Validate First Name
    if (!addFirstName) {
      newErrors.firstName = "First name is required.";
    }


    // Validate Last Name
    if (!addLastName) {
      newErrors.lastName = "Last name is required.";
    }

    // Validate Phone Number
    if (!addPhoneNumber) {
      newErrors.phoneNumber = "Phone number is required.";
    } else if (!/^\d{10}$/.test(addPhoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits.";
    }

    // Validate Country Code
    if (!addCountryCode) {
      newErrors.countryCode = "Country code is required.";
    }

    if (!trailsName) {
      newErrors.trailsName = "Trial is required.";
    }

    if (!trialIntroLabel) {
      newErrors.trialIntroductionLabel = "Trial Introduction is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleAddPatient = async (e) => {
    e.preventDefault();
   
    if (!validate()) {
      return; // Stop form submission if validation fails
    }
    setApiLoader(true)
    const responseBody = {
      firstName: addFirstName,
      lastName: addLastName,
      countryCode: addCountryCode,
      phoneNumber: addPhoneNumber,
      emailAddress: addEmail?addEmail:null,
      trialID: selectedTrailsNameId,
      TrialIntroductionID: trialIntroId
    };
    try {
      const response = await axios.post(ENDPOINTS.PATIENT.ADD_PATIENT, responseBody);
      setApiLoader(false)
      setAddfirstName('');
      setAddLastName('');
      setAddEmail('');
      setAddPhoneNumber('');
      // setAddCountryCode('');
      setTrailsName('')
      setTrailIntroLabel("")
      setSelectedTrailsNameId('')
      setApiLoader(false)
      addToast("The patients has been added successfully", "success");
    } catch (error) {
      setApiLoader(false)
      console.error('Error adding post:', error);
        const errorMessage = error?.response?.data?.message ?? "An unexpected error occurred!";
      

      setApiLoader(false)
      addToast(errorMessage, "error");
    }
  };
  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  useEffect(() => {
    if (!trialNamesList || trialNamesList.length === 0) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      dispatch(getTrailsName({})); 
    }
  }, [])

  const handleCharValueFirstName = (e) => {
    if (e.target.value.length <= 25) {
      setAddfirstName(e.target.value)
    }
  }

  const handleCharValueLastName = (e) => {
    if (e.target.value.length <= 25) {
      setAddLastName(e.target.value)
    }
  }

  return (
    <>

      <div className="w-[80%]">
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
        ))}
        <div >
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div>
              <label for="firstName" class="block form_label_color pb-4">
                First Name  <span className="aestrick_color">*</span>
              </label>
              <input
                type="text"
                id="firstname"
                name="firstName"
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12"
                // required
                // placeholder="Your First Name"
                value={addFirstName}
                onChange={handleCharValueFirstName}
              />
              <div className="text-xs w-full text-gray-600">
                {addFirstName.length} / 25
              </div>
              {errors.firstName && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.firstName}</p>}

            </div>
            <div>
              <label htmlFor="lastName" className="block form_label_color pb-4">
                Last Name  <span className="aestrick_color">*</span>
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12"
                // required
                // placeholder="Your Last Name"
                onChange={handleCharValueLastName}
                value={addLastName}
                />
              <div className="text-xs w-full text-gray-600">
                {addLastName.length} / 25
              </div>
              {errors.lastName && <p className="text-[#F95454] font-sans text-[14px] font-[500] mt-2">{errors.lastName}</p>}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 pt-8">
            <CountrySelector countryCode={addCountryCode} countryCodes={countryCodes} setCountryCode={setAddCountryCode} errors={errors} setAddPhoneNumber={setAddPhoneNumber} addPhoneNumber={addPhoneNumber} />
            <div>
              <label htmlFor="phoneNumber" className="block form_label_color pb-4">
                Email ID  (Optional)
              </label>
              <input
                type="text"
                id="email"
                name="email"
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12"
                onChange={(e) => setAddEmail(e.target.value)}
                value={addEmail}
              />
              {errors.addEmail && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.addEmail}</p>}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div className="w-full relative">
              <label for="timezone" class="block form_label_color pb-4">
                Trials  
                <span className="text-red-600"> *</span>
              </label>
              <select
                id="trailsName"
                name="trailsName"
                value={trailsName}
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleSelectChange}
              >
                <option value={""} selected>Select Trial</option>
                {trialNamesList?.map((tz) => (
                  <option key={tz.trialID} value={tz.trialName}>
                    {tz.trialName}
                  </option>
                ))}
                
              </select>
              {errors.trailsName && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.trailsName}</p>}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>
            <div className="w-full relative">
              <label for="timezone" class="block form_label_color pb-4">
                Intro Text
                <span className="text-red-600"> *</span>
              </label>
              <select
                id="trialIntroLabel"
                name="trialIntroLabel"
                value={trialIntroLabel}
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleSelectTrailIntroChange}
              >
                <option value={"Select TrialIntroduction"} selected >Select Trial Introduction</option>
                {trialIntro?.map((tz) => (
                  <option key={tz.trialIntroductionID} value={tz.trialIntroductionLabel}>
                    {tz.trialIntroductionLabel}
                  </option>
                ))}
                
              </select>
              {errors.trialIntroductionLabel && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.trialIntroductionLabel}</p>}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>

          </div>

          <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-0 w-full -ml-8 bg-white pl-8 flex gap-5 z-10">
            <button type="submit" className="px-7 py-1 text-base rounded-md border primary_btn transition-all duration-500" onClick={handleAddPatient}>{apiLoader ? <div className="flex justify-center"><div className="mini-spinner"></div></div> : "Add"}

            </button>
            <BackButton classes="text-[#1A1A1B!important] hover:text-[#ffffff!important]" />
          </div>

        </div>
      </div >
    </>
  );
};

export default AddIndividualPatient;
